import type { EdgeId } from '@ipfabric/utils';
import { nullable } from '@ipfabric/utils/fp/nullable';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { pipe } from 'fp-ts/lib/pipeable';
import { findNodeIdByNodeSn } from './helpers/findNodeIdByNodeSn';

interface SetPacketTracingPacketsCommand {
  successorPacketId: EdgeId;
}

export const setPacketTracingPackets: GraphCommandFactory<
  SetPacketTracingPacketsCommand
> = (cmdContext) => (command) => {
  const {
    graph,
    pathlookup: { pathInspector },
  } = cmdContext.getState();
  const nodeId = findNodeIdByNodeSn(graph, pathInspector.activeNodeSn);
  if (nodeId === null) {
    return;
  }
  pipe(
    graph.nodes[nodeId],
    nullable.chain((nodeData) => {
      cmdContext.updateState((draft) => {
        if (
          draft.pathlookup.pathInspector.selectedPackets[nodeData.sn] ===
          undefined
        ) {
          return;
        }
        // Fixed noUncheckedIndexedAccess NIM-19408
        draft.pathlookup.pathInspector.selectedPackets![
          nodeData.sn
        ]!.successorPacketId = command.successorPacketId;
      });
    }),
  );
};
